// extracted by mini-css-extract-plugin
export var rgpdContainer = "rgpd-module--rgpd-container--b11cb";
export var rgpdSubTitle = "rgpd-module--rgpd-sub-title--29813";
export var rgpdTitle = "rgpd-module--rgpd-title--be61e";